// When included on a page, auto attaches to the click events of data-toggle and opens a modal
// div targeted by the data-target attribute.
// Needs modal.css.

// Based on https://github.com/faurelia/simple-modal-view
export class Modal {
    public static Init(): void {
        new Modal();
    }

    constructor() {
        this.WireUpDataModals();
    }

    private WireUpDataModals(): void {
        // All data-toggle links will cause a modal to open.
        let elements = document.querySelectorAll('[data-toggle="modal"]');

        for (let element of elements) {
            element.addEventListener("click", (e) => this.onOpenClicked(e));
        }
    }

    public static CloseModal(): void {
        let modals = document.querySelectorAll(".modal.open");

        for (let modal of modals) {
            modal.classList.remove('open');
        }
    }

    // Can be called directly on an element to open it as a modal.
    // Also used by the auto wired up data- version.
    public static OpenModal(modalDivElement: HTMLDivElement, closeCallback: Function): void {

        this.addCloseEventListener(modalDivElement, closeCallback);

        let dismissElements = modalDivElement.querySelectorAll('[data-dismiss="modal"]');

        for (let element of dismissElements) {
            this.addCloseEventListener(element as HTMLElement, closeCallback);
        }

        this.CloseModal(); // Ensures we don't stack the modals if the caller does not close them before showing anew.
        modalDivElement.classList.add('open');
    }

    public static OnCloseClicked(e: Event, closeCallback: Function): void {
        Modal.CloseModal();

        if (closeCallback) {
            closeCallback();
        }

        e.preventDefault();
    }

    // Only adds the close listener to an element if it has not already been added when opened before.
    private static addCloseEventListener(element: HTMLElement, closeCallback: Function): void {
        if (!element.dataset.closeEventChecked) {
            element.dataset.closeEventChecked = "true";

            // And only add close clicks to elements with 'data-dismiss=modal'.
            if (element.dataset.dismiss === "modal") {
                element.addEventListener("click", (e) => Modal.OnCloseClicked(e, closeCallback));
            }
        }
    }

    private onOpenClicked(e: Event): void {
        let target = <HTMLElement>(e.target || e.srcElement);

        if (target.hasAttribute('data-target')) {
            let targetId = target.getAttribute('data-target');
            let element = <HTMLDivElement>document.getElementById(targetId);

            Modal.OpenModal(element, null);

            e.preventDefault();
        }
    }
}

document.addEventListener("DOMContentLoaded", () => { Modal.Init() });
